import { createGlobalStyle } from 'styled-components';
import { palette, font } from 'styled-theme';
import "./font.css";
const GlobalStyles = createGlobalStyle`

   .divident_download{
    display:flex;
    
   }

  .hightlight2 , .hightlight1{
    background: #e8f3ac !important;
   }
   .hightlight2:hover td , .hightlight1:hover td ,
   .ant-table-tbody > tr.hightlight2:hover:not(.ant-table-expanded-row) > td,
   .ant-table-tbody > tr.hightlight1:hover:not(.ant-table-expanded-row) > td{
    background: #e0ed96  !important;
   }
  .search_box .ant-input-group-addon{
    display:none;
  }
  .MT10{margin-top:10px!important}
  .MB20{margin-bottom:20px}
  .ant-btn{
    border-radius: 4px;
  }
  .loder{
    padding:30px 0px;
    text-align:center;
  }
  .otp_model .ant-modal-title{
    text-align: center !important;
    }
   .model_box_btn input:focus {
    box-shadow: none;
}
 .model_box_btn input[type=number]  {
 -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
textarea,
input[type="text"],
input[type="button"],
input[type="submit"] {
     -webkit-appearance: none;
}
input::-webkit-contacts-auto-fill-button {
  visibility: hidden;
  display: none !important;
}
.error_text{color: #ff4d4f;font-size:14px;}
.otp_model .ant-modal-header{
      border-bottom:0px !important;
      padding:35px 0px 5px !important;
    }
   .otp_model ant-modal-content{
      padding:20px 30px !important;
    }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
  }

  .ant-row.ant-form-item {
    margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }
  .ant-input, .ant-select {
    height:50px;
  }

  .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector{
    height:50px;
    overflow:auto;
  }.ant-select-single.ant-select-show-arrow .ant-select-selection-item,.ant-select-single.ant-select-show-arrow .ant-select-selection-search{
    padding:10px 0px !important;
  }
  .ant-picker-input{
    height:40px;
  }
  // .ant-picker {
  //    padding: 0 !important;
  // }
  .float-label{
    margin-bottom:0px !important;
  }
  .ant-row{
    // margin:20px;
    margin:20px 0 20px 0;
  }
  
  /*-----------------------------------------------*/
  // style for project category menu [ScrumBoard]
  /*-----------------------------------------------*/
  .project-category {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item {
        padding: 8px 12px;
        color: #000000;
        font-weight: 400;
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project menu [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-dropdown {
    &.project-menu {
      width: 280px;
      top: 133px !important;

      .ant-dropdown-menu {
        padding: 0;
        overflow: hidden;

        .ant-dropdown-menu-item {
          min-height: 54px;
          line-height: auto;
          display: flex;
          align-items: center;
          padding: 10px 20px;

          &:first-child {
            padding: 0;
            border-bottom: 1px solid #f4f6fd;

            &:hover,
            &:focus {
              background-color: #ffffff;
            }
          }

          &:hover,
          &:focus {
            background-color: #F3F5FD;
          }

          &:last-child {
            background-color: #E6EAF8;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for popover [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-popover {
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        margin: 5px 0;
        span {
          font-size: 14px;
          color: #788195;
          text-transform: capitalize;
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for modal [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .render-form-wrapper {
            padding: 10px;
            h2 {
              margin: 0;
            }
            form {
              padding: 15px 0 3px;
              .field-container {
                margin-bottom: 26px;
              }
            }
          }
        }
      }
    }
  }


/*-----------------------------------------------*/
  // style form previous GlobalStyles
  /*-----------------------------------------------*/

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
}

font-family: ${font('primary', 0)};

h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
li,
input,
textarea,
span,
div,
img,
svg {
  &::selection {
    background: ${palette('primary', 0)};
    color: #fff;
  }
}
.PB30{padding-bottom:30px}
.MB10{margin-bottom:10px}
.ant-row:not(.ant-form-item) {
  ${'' /* margin-left: -8px;
  margin-right: -8px; */};
  &:before,
  &:after {
    display: none;
  }
}

.ant-row > div {
  padding: 0;
}

.isoLeftRightComponent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70%;
}

.isoCenterComponent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.isoOtherLogin .isoCenterComponent {align-items: flex-start;}
.isoCenterComponent .column1{
  display:flex;
  flex-basis:60%;
  justify-content: right;
}
/********** Add Your Global CSS Here **********/

body {
  -webkit-overflow-scrolling: touch;background: #F1F3F6;font-size: 16px
}

html h1,
html h2,
html h3,
html h4,
html h5,
html h6,
html a,
html p,
html li,
input,
textarea,
span,
div,
html,
body,
html a {
  margin-bottom: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
  font-family: 'Myriad Pro Regular';
}
a {
  color:#59cbe8 ;
}
.resendotp{color:#59cbe8 ;cursor: pointer;}
.resendotp:hover{color:#0047ba ;}
.MT20{margin-top:20px}
.ant-btn:hover, .ant-btn:focus {
  color:#fff;
  background: #59cbe8;
  border-color: #59cbe8;
}
a.ant-typography, .ant-typography a{
  color:#59cbe8 !important;
}
a:active,a:hover  {
  color:#0047ba !important;
}
html ul {
  -webkit-padding-start: 0px;
  list-style: none;
  margin-bottom: 0;
}

.scrollbar-track-y,
.scrollbar-thumb-y {
  width: 5px !important;
}

.scrollbar-track-x,
.scrollbar-thumb-x {
  height: 5px !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
}

.scrollbar-track {
  background: rgba(222, 222, 222, 0.15) !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-bottomLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-bottomRight
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-topLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-topRight
  > .ant-popover-content
  > .ant-popover-arrow:after {
  left: 0;
  margin-left: -4px;
}

/* Instagram Modal */

.ant-modal-wrap.instagram-modal .ant-modal {
  max-width: 935px;
  width: 100% !important;
}
.ant-select{width:100%}
@media only screen and (max-width: 991px) {
  .invester_details_data > .ant-row > .ant-col {
    margin-bottom: 15px;
}
  .mobnowrappper{
    width: 95%!important;
  }
  .identify .identitynext {
    position: relative!important; 
    right: 0 !important;
    float: right;
    bottom: 0 !important;
    margin: 30px 0 20px;
}
.stepContent{padding: 12px!important;}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-title {
  width: 100%;
  line-height: 20px!important;
}
.ant-steps-item-title{
  font-size: 13px!important;
}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-content{
  min-height: 33px !important;
  display: flex !important;
  align-items: center;
}

  .ant-modal-wrap.instagram-modal .ant-modal {
    padding: 0 60px;
  }
}
  @media only screen and (max-width: 375px) {
  .logInPage .setupitsme {
    left: 7%!important;
}
  }
@media only screen and (max-width: 320px) {

  .verificationRespPDLR5{padding-left:5px!important;padding-right:5px!important}
 .shareconfig  .verificationResp  .label {
    width: 115px;
    font-size: 12px!important;
    top: 10px!important;
}
.shareconfig .verificationResp .label.label-float{
  width: auto!important;
  top: -8px!important;
}
 .ant-collapse .filter_btn Button {
    padding: 6px 24px!important;
}
.isoLayoutContentWrapper h1 {font-size: 16px!important;}
.titleButton {   
  font-size: 12px;
}
h1:before{margin-right:5px!important;}
}
@media only screen and (max-width: 767px) {
  .contactinforwrapper .contact_data > .ant-row > .ant-col.uploadFile {
    padding: 0 10px !important;
  }
  .scrollableList .ant-list-item{
    flex-wrap: nowrap;
  }
.resDeceasePD .deceasedwrapper .ant-col .ant-col,.resDeceasePD > .ant-col{
    padding: 0 !important;
}
.admin-Datepicker {
    margin-top: 10px!important;
}
.ant-col.PDL0{padding-left:10px!important}
.decMaxWidth.ant-col-xl-8{max-width:100%}
.dashboardbtn.download_excel {
    margin: 10px 0 10px;
    justify-content: left;
}
.shareholderButtonNxt {
    padding: 10px 25px 30px 25px!important;
}
.ant-modal.compStructMdl #labelfocus70 label {
    line-height: 14px;
    left: 8px;
}
    .ant-modal.compStructMdl #labelfocus70 label.label-float,
     .ant-modal.compStructMdl #labelfocus70.focuslabel label {
    left: 8px;
}
    .ant-modal.compStructMdl .focuslabel .label, 
    .ant-modal.compStructMdl .label.label-float{font-size:12px!important}
#labelfocus52.lineheigh15 .float-label .label,
#labelfocus77.lineheigh15 .float-label .label,
#labelfocus59.lineheigh15 .float-label .label,
#labelfocus51.lineheigh15 .float-label .label{top: 20px;}
    #labelfocus52.lineheigh15.focuslabel .float-label .label,
    #labelfocus52.lineheigh15 .float-label .label.label-float,
    #labelfocus59.lineheigh15.focuslabel .float-label .label,
    #labelfocus59.lineheigh15 .float-label .label.label-float,
    #labelfocus77.lineheigh15.focuslabel .float-label .label,
    #labelfocus77.lineheigh15 .float-label .label.label-float,
    #labelfocus51.lineheigh15 .float-label .label.label-float
    {top: -6px;}
    .learnedAbout label.label.label-float {
    left: 4px!important;
    right: 5px!important;
}
    .contactlearned.learnedAbout label.label.label-float{line-height: 11px;}
    .invester_details_data.legalinvetordetail .centerAlign, .invester_details_data.legalinvetordetail .rightAlign {
    text-align: left !important;
}
.ant-form .address #labelfocus12 .float-label label,
.ant-form  #labelfocus18.diffadd .float-label label{line-height: 10px;}
.ant-form .address #labelfocus12 .float-label label.label-float,
.ant-form  #labelfocus18.diffadd .float-label label.label-float{line-height: 10px;}
 .ant-form #labelfocus118 .float-label label,
 .ant-form #labelfocus67 .float-label label{
    line-height: 12px;
}
    .ant-form #labelfocus118 .float-label label.label-float{top: -6px;}
.shareDetails{
  display: flex!important;
  flex-direction: row;
}
.shareDetails .posLeft{
  text-align: left!important
}
.logInPage.itsmeLogin .identitywrapper {
    width: 90% !important;;
}
.multiUser {
    width: 100% !important;;
}
  form .ant-mentions, form textarea.ant-input {
    height: 48px !important;
    line-height: 38px;
}
.contactinforwrapper .balFontSize {
    font-size: 18px !important;
}
.setupitsme {
    position: absolute;
    bottom: 134px!important;
    left:10%!important;
    font-size: 14px;
}
.lineheigh15.labelSpace .label {
          right: 0 !important;
}
.ant-modal.compStructMdl .ant-modal-footer{overflow: hidden;}
.currinttext .ant-tooltip {
    max-width: 320px!important;
}
.compStructMdl .ant-row {
    display: block!important;        margin: 0;
}
  .compStructMdl   .ant-col-xs-12 {
    float: left;
    margin-bottom: 15px;        width: 50%;
}
.compStructMdl   .ant-col-xs-24 {
  float: left;
  margin-bottom: 15px;        width: 100%;
}
  .imgbreak {
    word-break: break-word;
    }
  .imagepreview.resAlign{align-items:start; justify-content:left}
  .center-qr{
    display: flex;
    justify-content: center;
  }
  .admin-btn{
    position:absolute!important;
    right:132px;
    top:17px;        padding: 8px 8px !important;
  }
  .shift-btn{
    right:80px;
  }
  .shift-lang .SwitcherBlockWrapper .themeSwitchBlock .themeSwitchBtnWrapper{
    right: 15px;
  }
  .btn-span {
    display: none!important;
  }
  .isoSignInPage .isomorphicTopbar .isoLeft{display:none!important}
  .hide-btn{
    display:none;
  }
  .setPosition{
      position:absolute!important;
      right:150px;
    }
  .selectmethodouter{
    min-width:auto!important;
  }
  // .isoUser {
  //   display:none!important;
  // }
  .SwitcherBlockWrapper .themeSwitchBlock .themeSwitchBtnWrapper{
    width:55px!important;position: absolute;    top: 19px;    right:70px;
  }
  .logInPage{
    max-width:95%!important;
  }
  .identify .identitynext {
    position: relative!important; 
    right: 0 !important;
    float: right;
    bottom: 0 !important;
    margin: 30px 0 20px;
}
  .selectmethod {
    min-width: auto!important;
}
.selectmethod .ant-radio-wrapper .ant-radio ~ span {
  max-width: 80%!important;
}
  .pephinttext .ant-tooltip {
    max-width: 100%!important;
}
  .lineRemove:after {content:none!important}
  .contactinforwrapper .ant-tabs-left > .ant-tabs-content-holder {
    padding: 15px 15px 15px 15px!important;
    margin-top: 15px;
}
  .contactinforwrapper .ant-tabs-left{display: block!important;}
  .contactinforwrapper .ant-tabs-tab{width:100%!important}
  .sharetoTransfer_Scroll .inputfield span{display:inline!important}
  .ant-modal.otp_model .opt_input  input {
    width: 45px !important;
}
  .sharetoTransfer_Scroll .inputfield .ant-input{margin-bottom:10px}
  .ant-drawer .isoRight  li.ant-menu-item.ant-menu-item-only-child:last-child {
    border-bottom: 0;margin-bottom: 0px;
}
 .ant-drawer .isoRight li.ant-menu-item.ant-menu-item-only-child {
    border-bottom: 1px solid #d9d9d9;
}
  .ant-popover{z-index: 2030!important;}
  .isoUserDropdown{
    width: 150px!important;
    min-width: 150px!important;
  }
  .invester_details_data > .ant-row > .ant-col {
   margin-bottom:15px
}
.invester_details_data >div {
  margin: 0!important;
}
   .approveSelect_btn .ant-select {
    margin-right: 10px;
}
  .approveSelect_btn{display:block!important;}
  .approveSelect_btn .excel-download{margin-top:10px}
  .uploadCoda label:first-child {
    max-width: 50px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.uploadCoda label:nth-child(2) {
  display: flex;
}
  .tableHeading {
   margin-top:10px
}
  .uploadCoda{margin-bottom:10px}
  .download_excel.excelCodafile,.cddnaturalwrapper{display:block!important}
  .mappedmodal .pop_btn {
    display: block;
}
.mappedmodal p{font-size:14px!important}
.mappedmodal button {
  margin-top: 10px;margin-right:7px;
}
.mappedmodal button:last-child {
  margin-right:0px;
}
  .ant-modal.mappedmodal {
    width: auto!important;
}
  h1.trsnctTitle {
    display: block;
}
h1.trsnctTitle:before {content:none}
  .identifydoc h2 {
    padding: 0 15px;
}
  .removespace .ant-col:nth-child(3) input {
    padding: 0px;
}
.removespace .ant-col:nth-child(3) span.ant-input-affix-wrapper {
  padding: 0 5px!important;
}
.contactinforwrapper .removespace, .contact_data .removespace{padding-top: 15px;}
.removespace .mobnowrappper {
  height: 140px;
  top: 0px;
  width: 95%!important;
  left: 9px;
}
.removespace.ant-input, .removespace .ant-select ,.removespace .ant-select.ant-select-in-form-item{
  height: 30px!important;
}


.contactinforwrapper .address > .ant-row > .ant-col ,
 .contactinforwrapper .contact_data  > .ant-row > .ant-col{
  padding: 0!important;
}
.contactinforwrapper .personal_data > .ant-row > .ant-col{    padding: 0 10px!important;}
.contactinforwrapper .ant-tabs-left > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  padding-left: 0px!important;
}
  .isoContentWrapper .isoStatNumber{font-size:30px!important;}
  .impactwrapper .card_details.personalinfo {
    height: auto!important;
    margin-bottom: 30px;
}
  .ant-drawer-header{
    padding: 16px 30px!important;
  }
  .ant-drawer-body {
    padding: 30px 30px 30px 30px!important;
  }
  .ant-drawer .isoRight li.isoUser .isoImgWrapper .userActivity {
    width: 10px;
    height: 10px;
    display: block;
    background-color: rgb(126, 211, 33);
    position: absolute;
    bottom: 0px;
    right: 3px;
    border: 1px solid rgb(255, 255, 255);
    border-radius: 50%;
  }
  .ant-drawer .isoRight li.isoUser .isoImgWrapper {
    width: 40px;
    height: 40px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: relative;
    background-color: rgb(25, 188, 185);
    color: rgb(255, 255, 255);
    border-radius: 50%;
  }
  .ant-drawer .isoRight .isoUser{list-style:none}
  .flexwrapper {
    display: flex;    padding-bottom: 10px;    border-bottom: 1px solid #999;
    justify-content: space-between;
}
  .barsMenu {
    display:block!important;
    position: absolute;
    top: 17px;
    right: 10px;        padding: 7px 15px !important;
}
.barsMenu.expend {
  top: 10px;
}
  h3 {
    font-size: 13px!important;
}
.fileUploader .fileContainer .chooseFileButton{    font-size: 12px!important;}
  .prefixtext{top: 15px!important;}
  .ant-picker-panel-container .ant-picker-panels{display:block!important}
  .prefixtext {
    font-size: 12px!important;
}
  .shareconfig h2 {font-size: 14px;}
  .shareconfig table td {
    min-width: 183px;
}
  .dashboard h2 {
   font-size: 18px!important;
  }
  .identify{    position: static!important;
    transform: none!important;}
  .sellsharewrapper .PB30{padding-bottom:10px!important}
  p{font-size:12px!important}
  .label,
  .ant-form .float-label label,
  label{    font-size: 13px!important;}
  .filter_btn Button {
    padding: 6px 34px!important;
}
.identitywrapper .img_div:hover {
  border-bottom:15px;
}
  .isoLayoutContentWrapper .dividendPrefer {
    padding: 35px 12%!important;
}
  .dividendheading h2{font-size:18px!important;    margin: 0px 0 20px!important;}
  .ant-table{
    transform: rotateX(180deg);
    overflow: auto;
  }
  .ant-table-container{transform: rotateX(180deg);}
  .titleButton.trsnctBtn{padding:0!important;display: block;    position: relative;margin-bottom: 10px;}
  h1{font-size:18px!important}
  .titleButton.trsnctBtn .ant-btn {
    padding: 8px 10px;    width: 48%;margin-bottom: 10px;
    float: left;
}
.titleButton.trsnctBtn .ant-btn:nth-child(2) {margin-right:0}
  .impactboxwrapper div{width:100%!important;}
  .impactwrapper .anticon-form, .impactwrapper .anticon-file-search, .impactwrapper .ion-android-refresh{font-size:14px!important}
  .impactwrapper .ant-col-xl-12{
    max-width:100%!important;margin-left: 0!important;
  }
  .impactwrapper .isoWidgetsWrapper{margin-bottom:10px}
  .titleButton span {
    margin-right: 0;
}
h1:after{content:none!important}
  .titleButton {   
    padding: 7px!important;
}
  .boarddetail .ant-row {
    margin:  0;
}
.boarddetail .ant-row .ant-col {
  margin-bottom: 5px;
}
.boarddetail .resMT10{margin-top:10px;    margin-left: auto!important;}
  .sharetoTransfer_Scroll{height:auto!important;}
  .inputfield {
    font-size: 13px!important;
}
  .verticalline {
    width: 100%;
    height: 2px!important;
    margin: 5px 0;
    background: #d9d9d9;
}
  .identitywrapper{display:block!important;}
  .ant-modal-wrap.instagram-modal .ant-modal {
    max-width: 580px;
  }
  .ant-col-4 {
    flex: 1 0 16.66666667% !important;
    max-width: 100%!important;
}
// .ant-col-10 {
//   flex: 0 0 100%!important;
//   max-width: 100%!important;
// }
// .invester_details_data .ant-col-10 {
//   flex: 0 0 41.66666667%!important;
//   max-width: 41.66666667%!important;
// }
.invester_details_data .respComm .ant-col {
  margin-bottom: 0px!important;
}
.invester_details_data .respComm .ant-row:nth-child(even) {
  margin-top: 15px !important;
}
}

.ant-modal-wrap.instagram-modal .ant-modal-content {
  border-radius: 0;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close {
  position: fixed;
  color: #fff;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close i {
  font-size: 24px;
}

.ant-modal-wrap.instagram-modal .ant-modal-content .ant-modal-body {
  padding: 0;
}

/********** Add Your Global RTL CSS Here **********/

/* Popover */

html[dir='rtl'] .ant-popover {
  text-align: right;
}

/* Ecommerce Card */

html[dir='rtl'] .isoCardInfoForm .ant-input {
  text-align: right;
}

/* Modal */

html[dir='rtl'] .has-success.has-feedback:after,
html[dir='rtl'] .has-warning.has-feedback:after,
html[dir='rtl'] .has-error.has-feedback:after,
html[dir='rtl'] .is-validating.has-feedback:after {
  left: 0;
  right: auto;
}

html[dir='rtl'] .ant-modal-close {
  right: inherit;
  left: 0;
}

html[dir='rtl'] .ant-modal-footer {
  text-align: left;
}

html[dir='rtl'] .ant-modal-footer button + button {
  margin-left: 0;
  margin-right: 8px;
}

html[dir='rtl'] .ant-confirm-body .ant-confirm-content {
  margin-right: 42px;
}

html[dir='rtl'] .ant-btn > .anticon + span,
html[dir='rtl'] .ant-btn > span + .anticon {
  margin-right: 0.5em;
}

html[dir='rtl'] .ant-btn-loading span {
  margin-left: 0;
  margin-right: 0.5em;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {
  padding-left: 25px;
  padding-right: 29px;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)
  .anticon {
  margin-right: -14px;
  margin-left: 0;
}

/* Confirm */

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-body > .anticon {
  margin-left: 16px;
  margin-right: 0;
  float: right;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns {
  float: left;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns button + button {
  margin-right: 10px;
  margin-left: 0;
}

/* Message */

html[dir='rtl'] .ant-message .anticon {
  margin-left: 8px;
  margin-right: 0;
}

/* Pop Confirm */

html[dir='rtl'] .ant-popover-message-title {
  padding-right: 20px;
  padding-left: 0;
}

html[dir='rtl'] .ant-popover-buttons {
  text-align: left;
}

/* Notification */

html[dir='rtl']
  .ant-notification-notice-closable
  .ant-notification-notice-message {
  padding-left: 24px;
  padding-right: 0;
}

html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-message,
html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
  margin-right: 48px;
}

html[dir='rtl'] .ant-notification-notice-close {
  right: auto;
  left: 16px;
}

html[dir='rtl'] .ant-notification-notice-with-icon {
  left: 0;
}
/* Dropzone */

html[dir='rtl'] .dz-hidden-input {
  display: none;
}
h1{ font-size: 20px;
  font-weight: bold;
  margin: 0 0 20px!important;
  position: relative;
  align-items: center;
  width: 100%;
  display: flex;
}
h2,.contact_title{font-size: 18px;font-weight: bold;margin: 30px 0px !important;position: relative;width: 100%;}
.upload_div{
  display:flex;
  flex-direction: column;
    align-items: center;
    gap:5px;
}
.upload_div >span{
  color:#808080;
  line-height:16px;
  margin:auto;
  width:80%;
}
h1:before {
  content: '';
  background: #19bcb9;
  height: 40px;
  width: 5px;
  display: block;
  margin: 0px 15px 0px 0px;
  display: flex;
}
h1:after {
  content: '';
  background: #E3E5E8;
  right: 0;
  border-top: 4px solid;
  top: 16px;
  height: 1px;
  border-top: 3px solid #19bcb9;
  z-index: 1;
  display: flex;
  width: 100%;
}
h2.after_line:after {
  content: '';
  background: #E3E5E8;
  position: absolute;
  right: 0;
  border-top: 4px solid;
  position: absolute;
  right: 0;
  top: 12px;
  height: -0.5em;
  border-top: 2px solid #333333;
  z-index: 1;width: 100%;
}
.ant-btn-primary {
  border-color: #19bcb9;
  background: #19bcb9;
}
.ant-btn-primary:hover {
  border-color: #17aaa7;
  background: #17aaa7;
  color:#fff;
}
.ant-btn-success {
  border-color: #C1D82F;
  background: #C1D82F;
  color:#fff
}
.ant-btn-success:hover {
  border-color: #B5CD23;
  background: #B5CD23;
  color:#fff
}
h2{font-size:18px;font-weight: bold}
h3{font-size:16px;font-weight: bold}
h4{font-size:14px;font-weight: bold}
h1 span {
  color:#000;margin-right: 17px;white-space: nowrap;
}
h2 span {
  background: white;
  position: relative;
  z-index: 2;
  padding-right: 20px;
}
.MR15{margin-right:15px}
i{color:#19bcb9}
.ant-btn{    height: 37px;
  padding:7px 22px 8px;}
  .ant-btn.ant-btn-success:hover, .ant-btn.ant-btn-success:focus{
    border-color: #B5CD23;
    background: #B5CD23;
    color: #fff;
  }
  .isoLayoutContentWrapper {
    height: auto!important;
    min-height: 100vh;
    display:block!important;
    background: #F1F3F6;
}
.bold{
  font-weight:bold;
 }
 .margin_30{
  margin:30px 0;
 }
 .download_excel,.cddnaturalwrapper{
  display:flex;
  justify-content: right;
  margin: 15px 0 10px;
 }
 .download_excel h2,.cddnaturalwrapper h2 {
  margin: 0!important;
}
.margin_top_30{
  margin-top:30px;
}
.page_topoption_radio_type {
  display:flex;
  gap:30px !important;
}
.page_topoption_radio_type span{
 padding:10px 30px;
 border:1px solid #797979;
 border-radius:5px;
}
.page_topoption_radio_type span.active_tab{
   background:#19bcb9;
   color:white;
   border:1px solid #19bcb9;
 }
.filter_btn{
  display :flex;
  justify-content:right;
  gap: 20px;
}
.multi_item_td{
  display :flex;
  justify-content:center;
  gap :10px;
  align-items:center;
}
.unmatchpayment .ant-select,.taxconfigtable .ant-select,.docTable .multi_item_td .ant-select{
  width:100px;height: 37px;
}
.unmatchpayment .label-float.label{top:-3px}
.unmatchpayment .label{top:8px}
.unmatchpayment .ant-select-single.ant-select-show-arrow .ant-select-selection-search,
.unmatchpayment .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
.taxconfigtable .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
.docTable .ant-select-single.ant-select-show-arrow .ant-select-selection-item{    padding: 3px 0px !important;}
.unmatchpayment .ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
.taxconfigtable .ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
.docTable .multi_item_td .ant-select-single:not(.ant-select-customize-input) .ant-select-selector{height: 37px!important;}
.docTable .ant-table-thead > tr > th{width:33%}
.docTable .multi_item_td{justify-content: flex-start;}
.btn_pd{
  padding:5px 10px !important;
}
.pop_btn{
  margin-top:20px;
  display :flex;
  justify-content:center;
  gap: 10px;
}
.buyshare_input{
  display:flex;
  flex-direction:column;
  gap:2px;
}
.relative{
  position:relative;
 }
.float_fix_label{
  position: absolute;
  top: -4px;
  left: 10px;
  z-index: 1;
  color: #808080;
  background: #fff;
  line-height: 11px;
}
}
.buyshare_input .ant-input{
  height:40px;
}
// pop_btn Button{
//   padding:6px 20px;
// }
.pop_btn
  .ant-btn {
    padding: 0 16px 0 16px!important;
}
.error{
  color:#ff4d4f;
}
 
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover{
  background:#00c4bb !important;
  border:1px solid #00C4BB !important;
}
.invester_details{
display:flex;
}
.invester_details_data >div{
margin-bottom:20px;
}
.invester_details_data >div >.ant-row{
  margin-bottom:7px !important;
  margin-top:7px !important;
  }
.invester_details_sidebar .ant-col{
background:#00C4BB;
color:white;
padding:10px 20px !important;
border:2px solid;
}
.invester_details_page .ant-tabs{
  height:100% !important;
}
.ant-tabs-tab{
  padding:13px 20px !important;
  width:230px!important ;
  border-style:solid !important;
  border-width:0px 1px 1px 1px !important;
  margin:0 0 0 !important;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list{
  border-style:solid !important;
  border-width:1px 0px 0px 0px !important;
}
.ant-tabs-tab-active{
  background:#00C4BB !important;
  border:1px solid rgb(121, 121, 121);
}
.ant-tabs-tab-active .ant-tabs-tab-btn{
  color:white !important;
}
.ant-tabs-tab:hover{
  color:#00C4BB !important;border: 1px solid #000;
}
.ant-tabs {
  gap:20px;
}
.ant-tabs-left > .ant-tabs-content-holder{
  border-left:0px !important;
}
.theme_color{
  color:#00C4BB;
}
.bold{
font-weight:bold;
} 
.font_16{
  font-size:16px;
}
.onboard_btn{
  display:flex;
  gap:30px;
  justify-content:end;
}
.ant-select-multiple .ant-select-selection-item{
  background:none !important; 
  border: none !important;
  height: 18px!important;
  line-height: 18px!important;
}
.ant-row {
  margin: 20px 0;
}
.ant-table-tbody > tr > td {
  font-size: 14px;
  color: rgb(121, 121, 121);
}
.ant-table-thead > tr > th{font-size:14px;background: #19bcb9!important;color: #fff!important;}
tr:nth-child(even){ 
  background: #fbfbfb;
}
.container{
  // max-width:1280px; 
  margin:auto;padding: 0 2%;
  width: 100%;}
.identitywrapper{
  display :flex;
  gap:15px; justify-content:center;
}

.identitywrapper > .ant-btn, .identitywrapper > a{
  border:1px solid transparent!important;
  height:auto !important;    padding: 7px 10px 8px;
}
.identitywrapper > .ant-btn:hover {
  background: none;
}
.identitywrapper > .ant-btn img , .identitywrapper > a img{
  border: 1px solid transparent;
}
.identitywrapper > .ant-btn img:hover,.identitywrapper > a img:hover  {
  border-radius: 5px;
  border: 1px solid #999;
}
  .ant-collapse > .ant-collapse-item > .ant-collapse-header{
    background: #19bcb9;    color: #fff!important;
  }
  .border_red > div,input.border_red, .signinpwd .border_red{
    border:2px solid #e60d2e !important;
     box-shadow:0px 0px 2px 0px #e60d2e !important;
  }
  .ant-picker.border_red_date_picker{
    border:2px solid #e60d2e !important;
    box-shadow:0px 0px 2px 0px #e60d2e !important;
   }

.ant-card{
  box-shadow:0px 2px 6px rgba(0,0,0,0.25);
}
.ant-card-body {
  padding: 0 24px !important;
}
.verticalline{
  border-left : 2px solid #d9d9d9;
  height: 40px;
}
.desctxt{
  width: 100%;
  height: 120px;
  overflow: auto; 
  border: 1px solid #d9d9d9;
  padding: 10px ;

}
.reviewDetail{
  font-weight: bold;
   font-size: 18px!important;
   margin:0!important
}
.view{
  border: 0;
  // border-right: 1px solid #ddd;
  border-radius: 0;
  // padding: 5px 8px;
  // margin: 0 0 0 0;
  background: transparent;
}
.testrun {
  border: 0;
  border-left: 1px solid #ddd;
  border-radius: 0;
  padding: 5px 10px;
  margin: 0 0 0 5px;
  background: transparent;
}
.titleButton {
  float: right;
  position: absolute;
  right: 0;
  z-index: 3;
}
.titleButton span{color:#fff}
.approveSelect_btn{
  // margin:20px 0 0 0;
  display :flex;
  justify-content:right;
  gap 10px;align-items: center;
}
.cat_table td {
  text-align: left !important;
}
.tableHeading{
  font-weight:bold;
}
.otp_model .ant-opt_input-body{
  padding: 0px !important;
  text-align:center;
  item-align:center;
}
.otp_model .ant-modal-body{
  color:rgba(51, 51, 51, 0.6980392156862745);
  text-align:center;
  padding:0px !important;
}
.ant-modal-body{
  width:auto;
}
.unmatchpayment th .ant-checkbox-wrapper{
  display:none!important
 }
.otp_model .opt_input{
  display: flex;
  gap :10px;
}
.otp_model .opt_input  input{
  width:50px !important;
  border:0px;
  text-align: center;
  border-radius: 0;
  border-bottom:1px solid rgba(51, 51, 51, 0.6980392156862745)
}
.otp_model .model_box_btn{
  display:flex;
  justify-content:center;
  align-items:center;
  flex-direction:column;
  padding:10px 0px 40px;
   gap:10px;
}
.otp_model .ant-modal-title{
  text-align: center !important;
  font-weight:700;
}
/* Optional: Adjust padding and other styles as needed */
.ant-select-dropdown-menu-item {
  padding: 8px 12px;}
.shareconfig h2 {
  margin: 10px 0 12px!important;
  padding: 0;
}
.hide{display:none}
.shareconfig i.ion-edit, 
.shareconfig .anticon.anticon-form,
.shareconfig .anticon-check-square,
.shareconfig .anticon-close-square  {
  position: relative;
  top: 15px; cursor:pointer;    font-size: 20px;
}
.shareconfig table .anticon-check-square,
.shareconfig table .anticon-close-square,
.shareconfig table .anticon.anticon-form{top:0}
.shareconfig .anticon-close-square  {
color:#e60d2e;
}
.shareconfig table .editable-row .ant-picker-input {
  height: 25px;
}
.shareconfig table td{ width:33.3%}
.shareconfig .anticon-check-square{color:#007336}
.shareconfig .ant-btn {
  position: relative;
  top: 6px;
}
.shareconfig .withdrawals h2 {
  margin: 0 0 30px!important;
}
.shareconfig .ant-row {
  margin: 0 0 30px;
}
.shareconfig .ant-switch{
 margin-left:20px;
}
.ant-switch-checked {
  background-color: #19bcb9!important;
}
.prefixtext {
  position: absolute;
  z-index: 1;
  top: 13px;
  font-size: 14px;
  left: 8px;
  font-weight: bold;
}
.shareconfig input.ant-input {
  text-align: center;
}
.sharetoTransfer_Scroll{
  width: 100%;
  height: 215px;
  overflow: auto; 
  padding: 0 10px 0 0;
  // border: 1px solid #d9d9d9;

}
.sharetoTransfer_Scroll .inputfield .ant-input{
  height: 25px;
  width: 70px;
  margin-right: 5px; 
}
.inputfield{
  padding:8px 0;font-size: 14px;
}
.sharetoTransfer_Scroll .inputfield{
  border-bottom: 1px solid #d9d9d9;
}
.sharetoTransfer_Scroll .inputfield:last-child{
  border-bottom:0;
}
.ant-table-wrapper{overflow:auto;    transform: rotateX(180deg);}
.unmatchpayment{margin-top:0}
.ant-table-tbody > tr > td .anticon ,.ant-table-tbody > tr > td i,
.ant-card-body .anticon {
  font-size: 20px;
}
.paymentReq a{
  position: absolute !important;
}
.boarddetail .ant-row .ant-row {
  margin: 0;
}
.boarddetail .ant-col {
  word-wrap: break-word;
}
.ant-notification-notice-message {
  min-height: 20px;
}
// .rightAlign .ant-row .ant-col-16 :nth-child(even){
//   text-align: right!important;
//   word-break: break-all!important;
// }
.ant-pagination{
  justify-content: center! important;
}
.configureDividend  {
  margin-left:10px;
  background: white;
  position: relative;
  z-index: 2;
  padding-right: 20px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #d8d8d8; 
}
::-webkit-scrollbar {
  height:10px;
  width: 8px; /* Set the width of the scrollbar */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #c6c4c4; 
}
.ant-table table{
  border: 1px solid #f0f0f0;
}
.ant-spin-container{
 transform: rotateX(180deg);
}
h1 button span{margin-right:0}
h1 .trsnctBtn{margin-right:0; float: none}
.MR10{margin-right:10px}
.ML10{margin-left:10px}
h1.trsnctTitle:after{content:none}
.isoRight .ant-menu-horizontal{border-bottom:0}
.impactwrapper .ant-col-xl-12{max-width:49%}
.impactwrapper .ant-col-xl-offset-1{margin-left:2%}
.dividendheading h2{
  text-align: center;
  font-size:25px;
  color:#B5CD23;
  font-weight: normal;
}
.dividendDesc p{
  text-align: center;
  margin-bottom: 30px;
  color: rgba(0,0,0,.4);
}
.dividendPrefer {
  padding: 35px 12%!important;
}
.dividendheading .ion-social-euro{
  padding: 0 10px 0 10px;
  color: #B5CD23;
}
.isoWidgetsWrapper .isoStickerWidget {
  width: 100%;
  display: flex;
  -webkit-box-align: stretch;
  align-items: stretch;
  overflow: hidden;
  border-radius: 5px;
}
.isoWidgetsWrapper .isoIconWrapper {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 80px;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.1);    text-align: center;
}
.isoWidgetsWrapper .isoContentWrapper {
  width: 100%;
  padding: 15px 15px 15px 15px;
  display: flex;
  flex-direction: column;
  text-align:center;
}
.isoContentWrapper .isoStatNumber {
  font-size: 30px;
  font-weight: bold;
  line-height: 1.1;
  margin: 0px 0px 5px;color:#fff
}
.isoContentWrapper .isoLabel {
  font-size: 16px;
  font-weight: 400;
  margin: 0px;
  line-height: 1.2; color:#fff;
  border-top: 1px solid rgba(255,255,255, .7);
}
.greencolor .isoContentWrapper .isoStatNumber span{
  font-size: 14px;
  font-weight: normal;
  padding-right: 10px;
}
.isoIconWrapper i {
  font-size: 40px; color:#fff
}
.isoStickerWidget.primarycolor{background: #59CBE8;}
.isoStickerWidget.greencolor{background: #CBDD5A;}
.isoStickerWidget.greencolor .isoLabel span {
  border-right: 2px solid rgba(255,255,255,.4);
  // padding-right: 30px;
      width: 50%;
}
.isoStickerWidget.greencolor .isoLabel span:nth-child(2) {
  border-right: 0;
  padding-right: 0;
}
 .isoContentWrapper .isoLabel {
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 3px;    align-items: center;
}
.greencolor .isoContentWrapper .isoStatNumber span.borderwrapper{
  position:relative;
    padding-left: 10px;
    display: inline-block;
    font-size: 30px;
    font-weight: bold;
    padding-right: 0;
}
.greencolor .isoContentWrapper .isoStatNumber span.borderwrapper:before {
  content: '';
  height: 24px;
  width: 1px;
  background: rgba(255,255,255,.7);
  display: block;
  position: absolute;
  left: 0;
  top: 8px;
}
.greencolor .isoContentWrapper .isoStatNumber span.borderwrapper span{padding-right:0}
.MT0{margin-top:0px;}
.impactdetail{    background: rgb(223,223,0,.3)!important;
  border: 2px solid #E1E000!important;}
  .impactdetail .bookmark {
    display: flex;
    justify-content: space-between;
    position: relative;
    top: -20px;
    font-size: 50px;
    color:#E1E000;
}
.impactdetail .bookmark i{
  color:rgba(223,223,0,.7);
}
.impacttitle{    font-size: 16px;
  font-style: italic;
  text-align: center;
  line-height: 20px;font-weight:bold;
}
  .impactboxwrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content:space-between;
    padding: 20px;
    text-align: center;
}

.impactboxwrapper div{
  width:47%;
  background:rgba(223,223,0,.4);
  padding: 15px;
  margin: 10px 0;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.25);
}
.impactboxwrapper div:nth-child(2),.impactboxwrapper div:nth-child(3){
  background:#F2F2F2;
}
.impactboxwrapper i {
  font-size: 40px;
  color: #fdffaa;
}
.impactboxwrapper div:nth-child(2) i, .impactboxwrapper div:nth-child(3) i{
  color:#e6e976;
}
.isoInputWrappers {
  margin-bottom:20px 
}
.fileUploader .fileContainer{ text-align: center;padding: 10px 0;box-shadow:none}
.fileContainer p {
  margin: 8px 5px 4px!important;display:none;
}
.identifydoc h2{    margin: 0!important;}
.identifydoc p,.identifydoc span {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}
.identify {
  text-align: left;
  position: absolute;
  top: 40px;
  transform: translate(-50%, 0);
  left: 50%;
}
.loadMoreBtn{
  text-Align: center;
  margin-top: 10px;
}
.impactwrapper .anticon-form, .impactwrapper .anticon-file-search, .impactwrapper .ion-android-refresh{font-size:22px}
.impactboxwrapper p{font-style: italic;
  color: rgba(0,0,0, .6);
  font-size: 16px;}
  .ML5{margin-left:5px;}
  // .personalinfo{min-height:400px;}
  .sell {
    color: #e60d2e;
}
.buy {
  color: #007336;
}
.inProgress {
  color: #59CBE8;
}
.successBtn {
  background: #007336;
  color: #fff;
  padding: 5px 8px;
  border-radius: 5px;
}
.inProgressBtn {
  background: #59CBE8;
  color: #fff;
  padding: 5px 8px;;border-radius: 5px;
}
.failBtn {
  background: #e60d2e;
  color: #fff;
  padding: 5px 8px;border-radius: 5px;
}
.inProgressOrgBtn {
  background: #F7B500;
  color: #fff;
  padding: 5px 8px;
  border-radius: 5px;
  white-space: nowrap;
}
.ant-btn-danger{
  background: #e60d2e;
}
.ant-btn-danger:hover,.ant-btn-danger:focus{
  background: #fc1638;
  border: 1px solid #fc1638;
}
.failColor,.policylink {Color: #e60d2e;}
.policylink:hover {Color: #f93250!important;}
.inProgressColor {color:#59CBE8}
.successColor {color:#007336}
.audittrail h2 {
  margin-top: 0!important;
}
.audittrail .ant-btn-icon-only > .anticon {
  display: block;
}
.borderTop{border-top: 5px solid rgb(34, 188, 185)!important;}
h1.pageTitle:before,h1.pageTitle:after{content:none}
.download_excel span.anticon {
  font-size: 20px;
}
.ant-checkbox-checked .ant-checkbox-inner,.ant-radio-inner::after {
  background-color: #59CBE8!important;
  border-color: #59CBE8!important;
}
.ant-radio-checked .ant-radio-inner,.ant-checkbox-checked::after{
  border-color: #59CBE8!important;
}
.emailbreak,.countryBreak {
  word-break: break-word;
}
.countryBreak {
    padding-right: 10px;
}
.dashboard{position:relative;}
.dashboard h2 {
 margin:20px 0 20px!important
}
.shareconfig table .ant-row {
  margin: 0;
}
// .ant-fullcalendar-header .ant-picker-header-view .ant-picker-year-btn,
// .ant-picker-header-super-next-btn,.ant-picker-header-super-prev-btn
// {
//   display:none!important;
// }
// button.ant-picker-year-btn {
//   display: none;
// }
.shareconfig .label{    font-size: 14px;    left: 10px;}
.ant-collapse-content{background-color: #F8F8F8!important;}
table th:first-child {
  min-width: 65px;
}
.ant-select-single:not(.ant-select-customize-input) .ant-select-selector{
  height:50px!important
}
.themeSwitchBtnWrapper .ant-select-single:not(.ant-select-customize-input) .ant-select-selector{
  height:32px!important
}
.withprefixwrapper label.label {
  top: -3px;
  background-color: white;
  z-index: 1;
  line-height: 8px;
  padding: 0 2px;
}
.shareconfig span.anticon.anticon-form {
  color: #59cbe8;
}
.shareconfig span.anticon.anticon-form:hover {
  color: #0047ba;
}
.buysharewrapper ul {
  background: #fafafa;
  padding: 20px!important;overflow: hidden;
}
.buysharewrapper ul li {
  width: 49%;
  float: left;
  margin-right: 2%;margin: 0 2% 10px 0;color: rgba(0,0,0,.5);
}
.buysharewrapper ul li i {
  font-size: 25px;
  padding-right: 15px;
  vertical-align: top;
  display: inline-flex;
}
.buysharewrapper ul li:nth-child(even) {
  margin-right: 0;
}
.buyshare-impactinfo p{font-style:italic;color: rgba(0,0,0,.7);}
.buysharewrapper p{margin-bottom:7px;}
.focuslabel .label , .focuslabel-fix .label{
  top: -3px;
  background-color: white;
  z-index: 3;
  line-height: 8px;
  padding: 0 2px;
  font-size: 14px;
  color: #808080;
}
// .ant-form label {
//   font-size: 15px!important;
// }
/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px white inset !important;
}
.ant-input-affix-wrapper{padding:0 11px!important}
.fileContainer .uploadIcon {
  display:none;
  width: 35px!important;
  height: 35px!important;
}
.fileContainer .chooseFileButton {
  font-size: 12px!important;
  margin: 2px 0!important;padding:3px 10px!important
}
.fileUploader .fileContainer {
  padding: 5px 10px!important;
}
.approveSelect_btn .ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
.approveSelect_btn .ant-select
{
  height: 37px!important;
}
.approveSelect_btn .ant-select-single.ant-select-show-arrow .ant-select-selection-search ,
.approveSelect_btn .ant-select-single.ant-select-show-arrow .ant-select-selection-item
{
  padding: 3px 0px !important;
}
.shareholder-success {
  text-align: center;
}
.shareholder-success h2 {
  color: #19bcb9;    margin-bottom: 10px!important;
}
.ant-form-item .ant-row.ant-form-item-row {
  margin: 0;
}
form .ant-form-item {
  margin-bottom: 10px;
}
.text-right{text-align:right}
.centerAlign {
  text-align: center!important;
}
.capitalize {
  text-transform: capitalize;
}
.invester_details_data h3.txtHeading {
  font-size: 14px;
}
.ant-picker-range-separator {
  padding: 0 3px!important;
}
.ant-picker-range{    padding: 4px 10px !important;}
.ant-btn-primary.default-primary {
  background: #59CBE8;
  border: 1px solid #59CBE8;
}
.ant-btn-primary.default-primary:hover {
  background: #53bed9;
}
.invester_details_data .ant-card.ant-card-bordered {
  border-top: 4px solid rgb(34, 188, 185);
}
.legalAddMargin{margin-top:0}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after{border-bottom:2px solid transparent!important}
.ant-menu-horizontal > .ant-menu-item:hover a,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover,
.ant-menu-horizontal>.ant-menu-item-selected a,
.ant-menu-horizontal > .ant-menu-item a.active {
  color: #19bcb9!important;
}
.ant-menu-horizontal > .ant-menu-item::after, .ant-menu-horizontal > .ant-menu-submenu::after{ border-bottom:0!important}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover::after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active::after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open::after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after{
  border-bottom:0!important
}
.ant-menu-horizontal > .ant-menu-item a{    font-size: 16px;}
.capitalize{text-transform:capitalize}
.boardappTable table th:first-child {
  min-width: 30px;
  padding-right: 0!important;
}
.boardappTable table th:nth-child(2) {
  padding-left: 0px!important;
}
.MT30{margin-top:30px}
.pull-right{float:right;}
.barsMenu{display:none;}
.ant-input-affix-wrapper-focused, .ant-input-affix-wrapper:focus{z-index:0!important}
.admin-Datepicker{margin-top:-10px}
.ant-btn.admin-btn {
  padding: 8px 15px;
}
.personalinfo .legalinfo{
  margin:20px 0!important;
}
.isoSignInForm button a:hover{color:#fff!important}
.imagepreview{
  justify-content: center;
    display: flex;
    align-items: center;
    height: 100%;
}
.ant-form-item-has-error .fileUploader .fileContainer {
  border: 1px solid #ff4d4f;
}
.imagepreview h4{margin-right: 10px;}
.imagepreview img.uploadPicture {
  cursor: pointer;
  max-height: 80px;
}
.hideyear button.ant-picker-year-btn {
  display: none;
}
.invester_details_data span.anticon.anticon-form {
  color: #59cbe8;
}
.invester_details_data span.anticon.anticon-form:hover {
  color: #0047ba !important
}
.react-datepicker-popper {
  z-index: 5!important;
}
.react-datepicker-wrapper input {
  border: 1px solid #d9d9d9;
  height: 50px;
  width: 100%;    padding: 0 10px;
  outline:none;
}
.react-datepicker-wrapper input[disabled]{
  color: rgba(0,0,0,.4);
}
.react-datepicker-wrapper input:focus,.react-datepicker-wrapper input:hover {
  border: 1px solid #40a9ff;
}
.react-datepicker-wrapper {
  width: 100%;
}
.loder {
  position: fixed;
  z-index: 99999;
  height: 3em;
  width: 3em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.loder:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.6);
}
.boarddetail .ant-select,.boarddetail  .ant-select-selector,
.boarddetail .ant-select-single:not(.ant-select-customize-input) .ant-select-selector
{
  height: 37px!important;
}
.boarddetail .ant-select-single.ant-select-show-arrow .ant-select-selection-item, 
.boarddetail .ant-select-single.ant-select-show-arrow .ant-select-selection-search {
  padding: 3px 0px !important;
}
.isoRight ul.ant-menu {
position:relative
}
.isoRight ul.ant-menu:after {
  border-right: 1px solid #d9d9d9;
  content: '';
  position: absolute;
  right: 0;
  height: 30px;
  width: 10px;
  top: -5px;
  display: block;
}
button .anticon{    font-size: 20px;vertical-align: middle;} 
.taxDoc table{width:100%; text-align:left}
.print-only{
  display:none!important;
}
@media print {

.graphprintwidth canvas {
    width: 400px !important;
}
    .indgraphprintwidth canvas{width:320px!important}
.hide-on-print{
  display: none!important;
}
.print-only{
  display:flex!important;
}
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
  a[href]:after {
    content: none !important;
}
  .taxDoc table td{border:0!important}
  .taxDoc table {border:0!important}
  .taxDoc table.borderwrapper {border:.5px solid #c6c6c6!important}
  .taxDoc table.borderwrapper.border0Top{border-top:0!important}
  // .taxDoc table.borderwrapper td{border-right:1px solid #000!important}
  .taxDoc table.borderwrapper td:last-child{border-right:0!important}
  .taxDoc table .borderTopBlack{border-top:.5px solid #c6c6c6!important}
  tr:nth-child(even) {
    background: #fbfbfb;
}
table tr  td {
  color: rgb(121,121,121);
}
  @page {
    margin:20px 10px;
  }

   .printtoshow .logo{max-width:180px;} 
   .printtoshow h2{font-size:20px;border-top:1px solid #d4d4d4;padding-top:15px; margin:20px 0 15px!important}
   .shareholdDetail{
    padding:10px 0;margin-top:30px!important
   }
   .printtoshow h3{font-size:16px}
  .printtoshow {
    overflow: visible;
    height: fit-content;
  }
  .printtoshow th.ant-table-cell {font-size:12px;
    background: #F1F3F6!important;
    color: #000!important;
    font-weight: bold; border-right:1px solid #d4d4d4;
    padding:8px 7px;text-align:center;
}
.printtoshow .ant-table-wrapper{display:block}

.printtoshow td.ant-table-cell { border-right:1px solid #d4d4d4;font-size:12px; padding:8px 7px;text-align:center;}
.printtoshow td.ant-table-cell:last-child,
.printtoshow th.ant-table-cell:last-child{border-right:0}
.printtoshow table {
  border: 1px solid #d4d4d4;text-align:center;font-size:12px
}

.printtoshow .successBtn{background:transparent;color:#007336;}
.printtoshow .inProgressOrgBtn{background:transparent;color:#F7B500;}
.printtoshow th.ant-table-cell:before {content:none!important}
.printtoshow html ul {
  list-style: disc;
}
.dividendDoc .docTable .ant-table-thead > tr > th {
  width: 20%;
}
.dividendDoc ul{list-style:disc;margin-left:10px}
.dividendDoc ul li{margin-left:15px}
.dividendDoc h2{border-top:0}
}
// print view end
.excel-download{
  background: #007336; border: 1px solid #007336;color:#fff; padding: 8px 15px;
}
.excel-download1{
  background: #007336; border: 1px solid #007336;color:#fff; padding: 8px 15px; margin-left: 8px;
}
.excel-download1:hover,.excel-download1:focus{
  background: #08a652;color:#fff
  border: 1px solid #08a652;
}
.excel-download:hover,.excel-download:focus{
  background: #08a652;color:#fff
  border: 1px solid #08a652;
}
.ant-form-item-has-error .react-datepicker-wrapper input , .border_error , .border_error_select > .ant-select-selector {
    border: 1px solid #ff4d4f !important;
}
.ant-btn[disabled], .ant-btn[disabled]:hover, .ant-btn[disabled]:focus, .ant-btn[disabled]:active {
  color: rgba(0, 0, 0, 0.25)!important;
  border-color: #d9d9d9!important;
  background: #f5f5f5!important;
}
.ant-btn.ant-btn-default:hover, .ant-btn.ant-btn-default:focus{
  color: #000;
    background: #fff;
    border-color: #000;
}
.isoDashboardMenu li:first-child .isoMenuHolder,
.isoDashboardMenu li:nth-child(2) .isoMenuHolder{color: rgb(34, 34, 34)!important;}
.isoDashboardMenu li{border-top:1px solid #D9D9D9}
// .paymentdetailheading{
//   text-align:center;
// }
.transfertxt{
  padding-top: 10px;
  padding-bottom: 10px;
  // font-weight: bold;
}
.alterfinTxt{
  margin-top:10px
}
.paymentBackColor{
  // background-color: #19bcb930;
  // padding: 10px 20px 10px 20px;
}
.removespace .ant-col:nth-child(2),.removespace .ant-col:nth-child(3) {
  padding-left: 15px!important;
}
// .removespace .ant-col:nth-child(3) {
//   padding-right: 15px;
// }
.removespace .ant-col:nth-child(3) input {
  height: 30px;
  background: transparent;
}
.removespace .ant-col input {
  height: 30px;
}
.ant-layout-sider-collapsed.isomorphicSidebar h3 img.cvsologo {
  top: 15px;
}
.removespace .ant-col:nth-child(4) {
padding-left:15px!important;padding-right:15px!important;
} 
.removespace h3 {
  padding-top: 10px;
}
.removespace .ant-col:nth-child(3) span.ant-input-affix-wrapper {
  height: 30px;
}
.ant-pagination-options-size-changer.ant-select {
  display: none!important;
}
.mobnowrappper {
  position: absolute;
  width: 71%;
  /* margin: auto; */
  left: 15px;
  height: 54px;
  top: 0px;
  border: 1px solid #d9d9d9;    border-radius: 2px;
}
.removespace .ant-col{    margin-top: 17px;}
.removespace .ant-col .ant-col{margin-top:0}
.removespace .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 30px!important;
}
.removespace .ant-select-single.ant-select-show-arrow .ant-select-selection-search,
.removespace .ant-select-single.ant-select-show-arrow .ant-select-selection-item{
  padding: 0px 0px !important;
}
.mobnowrappper span{position:absolute;    
  top: -10px;
  background: #fff;
  left: 15px;color:#808080}
.trafficlight{display:flex}
.trafficlight img {
  max-width: 40px;
  margin-right:7px;
}
.ant-alert-close-icon{width:auto!important}
.ant-table-expanded-row .ant-table{margin:0!important}
.contactinforwrapper .contact_data .mobnowrappper{width: 85%;}
.contactinforwrapper .ant-row .ant-row.removespace{margin:0}
.contactinforwrapper .contact_data .ant-row .ant-row{
  margin-bottom: 0!important;
}
.imageColor{
  color:#59cbe8;    padding-right: 5px;
}
.ant-notification{z-index:2000}
.ant-table .ant-table th{
  background: #dfdfdf!important;
  color:rgb(121,121,121)!important;
}
.ant-table .ant-table td{
  background: #f4f2f2!important;
  color: rgb(121,121,121)!important;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]:hover,
input[type="number"]:focus {
  -moz-appearance: number-input;
}
.uploadCoda{
    display: flex;
    gap: 10px;
    margin-right: 10px;    align-items: center;
}
.ion-clock{
  color: rgba(223,223,0,1);
}
.CloseSquareOutlined{
  color:red
}
.verified{
  color:green
}
.resentmail img{display:none;position:relative}
.resentmail:after {
  position: absolute;
  content: '\f49d';
  font-size: 25px;
  font-family: 'Ionicons';
  top: 9px;
  animation: rotation 1s infinite linear;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
input#file-upload1[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.disable {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
  pointer-events:none
}
.ant-modal-mask{    z-index: 2050!important;}
.ant-modal-wrap {
  z-index: 2090!important;
}
.sellsharemodal .ant-modal-body{text-align:center;}
.ant-table-filter-trigger{color: #e5e5e5!important;}
.totalsellwrapper {
  border: 1px solid #d9d9d9;
  padding: 10px;position:relative;
}
.totalsellwrapper span {
  position: absolute;
  top: -13px;
  background: #fff;
}
.totalsellwrapper .ant-row {
  margin-bottom: 0;    margin-top: 3px;
}
.unmatchmodal .ant-modal-body,.mappedmodal .ant-modal-body{
  padding: 24px 50px;text-align:center
}
.ant-modal.mappedmodal{width:560px!important}
.totalsellwrapper label {
  font-size: 13px;color:#808080
}
.lightBlack{color:#808080}

.ant-modal-title,.ant-modal-footer{    text-align: center!important;}
.ant-modal-title{font-weight: bold!important;}
.tbl_payments table th:first-child {
  min-width: auto; 
}
// .tbl_payments table th,.tbl_payments table td{white-space:nowrap}
.ant-pagination button .anticon {
  font-size: 12px;
  position: relative;
  top: -1px;
}
.filter_btn.mapbtn{    justify-content: center;}
.filter_btn.mapbtn .ant-btn {
  height: 45px;
  padding: 7px 40px 8px;
}
.tbl_payments input.ant-input {
  height: 32px;
  background: transparent;
  color: rgb(121,121,121);
  border: 0;padding:0;    width: auto;
}
.tbl_payments .ant-input-group-addon .ant-btn{    height: 32px;
  background: transparent;
  padding: 0;
  border: 0;width: auto;
}
.tbl_payments .ant-input-group-addon .ant-btn span{width:15px; color: rgba(0, 0, 0, 0.3);}
.tbl_payments .ant-input-group-addon{    background-color: transparent;}
.tbl_payments table th {
  // padding: 8px 8px!important;vertical-align:top
  max-width: 85px;
    padding: 0px 5px!important;
    height: 50px;
}
.tbl_payments input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.3) !important;font-size:14px
}
.tbl_payments input.ant-input:focus{box-shadow:none;}
.tbl_payments .ant-input-group-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.3);padding: 0 5px;display:block;
}
.sellsharewrapper h3.tableHeading {
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 5px;
}
.tbl_payments .ant-table-thead tr:last-child, .tbl_payments .ant-table-thead tr:last-child th {
  background:#fff!important
}
.tbl_payments .ant-table-thead tr:first-child {
  background:#19bcb9 !important;
}
// .tbl_payments .ant-table-thead tr th{border-bottom: 0}
.tbl_payments .idwidth input.ant-input {
  width: 90px;
}
.tbl_payments table td {
  max-width: 85px;
}
.tbl_payments table .multi_item_td{display:block!important}
.tbl_payments.adminId .ant-table-thead tr:first-child th:first-child{
  background: linear-gradient(180deg, #19bcb9 50%, #fff 50%)!important;border-radius: 0;
  padding: 0!important;
}
.tbl_payments .ant-input-group{display:block;}
.tbl_payments.adminId .ant-table-thead tr:first-child {
   background: transparent !important; 
}
.text-center{text-align:center}
.tbl_payments .ant-input-group-wrapper .ant-input-affix-wrapper {
  border: 0;box-shadow:none;padding:0!important; 
}
.paymentdetailheading{text-transform:uppercase}
.ant-select.ant-select-multiple {
  height: auto;
}
.multiinvestor.ant-select.ant-select-multiple {
  height: auto;
}
.multiinvestor.ant-select.ant-select-multiple .ant-select-selector {
  height: auto!important;
}
.ant-table-tbody > tr > td .anticon.anticon-down{    font-size: 12px;}
.removespace .ant-select.ant-select-in-form-item{
  height: 30px!important;
}
.contactads .ant-row {
  margin: 5px 0;
}
.contactads h3 {
  font-size: 15px;
}
.contactads h2 {
  font-size: 16px;
}
.personalinfo.contactads .legalinfo {
  margin: 0px 0 0px!important;
}
.contactinforwrapper .ant-row .imagepreview .ant-row{    margin: 0!important;}
.informationwrapper .imagepreview .ant-form-item{margin-bottom: 0px;}
.lineRemove:after {
  content: '';
  position: absolute;
  width: 10px;
  background: #F1F3F6;
  z-index: 2;
  display: block;
  top: 0px;
  height: 37px;outline:none;
}
.lineRemove.Payment:after {right: 154px;}
.lineRemove.ConfigDiv:after {right: 160px;}
.lineRemove.ConfigDivTwo:after {right: 0px;}

.lineRemove.TaxConfig:after {
  right: 126px;
}
// .ant-btn.titleButton:focus{
//   border: none;
// }

//  .ant-btn.titleButton, .ant-btn.titleButton:focus, .ant-btn.titleButton:active{box-shadow: none !important;outline: none!important;}
.ant-drawer .isoRight ul.ant-menu:after,.ant-drawer .ant-menu-vertical{border-right:0}
.react-datepicker {border:0!important;box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);}
.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {
  font-weight: 500!important;
}
.react-datepicker__header {
  background-color: #fff!important;
  border-bottom: 1px solid #f0f0f0!important;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  border-bottom-color: #ffffff!important;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  box-shadow: 2px 2px 6px -2px rgba(0, 0, 0, 0.1)!important;
  border-bottom-color: #ffffff!important;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{transform: translate(25px, 0px)!important;}
.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, 
.react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, 
.react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, 
.react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, 
.react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, 
.react-datepicker__year-text--in-range,
.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, 
.react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
  border-radius: 0!important;
  background-color: #1890ff!important;
  color: #fff!important;
}
.react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover {
  border-radius: 0!important;
}
.react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {
  border-width: 2px 2px 0 0!important;
  height: 7px!important;
  top: 10px!important;
  width: 7px!important;
}
.react-datepicker__header select {
  border: 1px solid #d9d9d9;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
   padding: 3px 5px;    outline: none;
}
.react-datepicker__header select.react-datepicker__year-select{ padding-right: 15px;}
.react-datepicker__header .react-datepicker__month-dropdown-container:after,
.react-datepicker__header .react-datepicker__year-dropdown-container:after{
  content: '\f3d0';
  font-family: 'Ionicons';
  position: absolute;
  font-size: 16px;
  right: 4px;
  color: rgba(0, 0, 0, 0.25);
  top: 3px;
}
.react-datepicker__header .react-datepicker__month-dropdown-container, 
.react-datepicker__header .react-datepicker__year-dropdown-container {
  position:relative; 
}
Button[disabled].titleButton span {
  color: rgba(0,0,0,0.25)!important;
}
.ant-btn.ant-btn-default.view:hover, .ant-btn.ant-btn-default.testrun:hover,
.ant-btn.ant-btn-default.view:focus, .ant-btn.ant-btn-default.testrun:focus  {
  color: #000;
  background: transparent;
  border-color: #ddd;
}
.ant-btn.ant-btn-default.view, .ant-btn.ant-btn-default.testrun {
  color: rgb(121,121,121);
  padding: 0 10px 0px;
  box-shadow: none;
  height: 30px;
}
.displayFlex{display:flex;    justify-content: center;}
.contactinforwrapper .imagepreview {
  display: block;
}
.ant-tabs-tabpane h2.after_line {
  margin-top: 0!important;
}
.docTable .ant-btn-danger.btn_pd {
  color: #e60d2e;
  background: transparent;
}
.docTable .ant-btn-danger.btn_pd:hover, .docTable .ant-btn-danger.btn_pd:focus {
  background: #fc1638;
  color:#fff;
}
.btn_pd_download {
  height: 30px;
  padding: 0px 4px !important;
  margin-left: 10px
}
.btn_pd_download .anticon + span {
  margin-left: 3px;    font-size: 13px;
}
.btn_pd_download .anticon  {
  font-size: 16px!important;
}
.sharetoTransfer_Scroll .inputfield span {
  min-width: 260px;
  display: inline-block;
}
.react-datepicker__input-container .react-datepicker__calendar-icon {
  right: 0;
  top: 10px;
}
.react-datepicker__view-calendar-icon input {
  padding: 6px 25px 5px 10px!important;
}
span.btnDefault {
  background: rgb(121,121,121);
  color: #fff;
  padding: 5px 8px;
  border-radius: 5px;
}
.contactinforwrapper .imagepreview .customepreview .uploadPictureContainer{    
  display: flex;
  gap: 10px;
  width: 100%;
}
.contactinforwrapper .imagepreview .customepreview .uploadPictureContainer a{    
  // width: 90%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;text-align: center;
}
.ant-table-wrapper.docTable, .ant-table-wrapper.taxconfigtable{overflow:visible}
.contactinforwrapper .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: rgba(0, 0, 0, 0.85)!important;
  font-weight: 600;text-shadow: none !important;
}
.contactinforwrapper  .ant-tabs-tab-active {
  background: #f1f3f6 !important;
}
.contactinforwrapper .ant-tabs-tab {
  border: 1px solid #e9e9e9!important;
  border-top: 0!important;
}
.contactinforwrapper .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list{border-top: 1px solid #e9e9e9!important;}
.contactinforwrapper .ant-tabs-left > .ant-tabs-content-holder {
  border: 1px solid #e9e9e9!important;
  padding: 15px 15px 15px 0;
}
.ant-tabs-ink-bar {
  background: #19bcb9!important;
}
.react-datepicker-wrapper input[disabled]:hover{
  border:1px solid #d9d9d9
}
.printtoshow.taxDoc
{
  background: white; border:0px!important
}
.taxDoc table td{padding:7px;color:rgba(0, 0, 0, 1); text-align:left;border:0!important}
.taxDoc table tr {
  background: white;
}
.taxDoc {
  margin:30px 20px ;
}
// .taxDoc .tableMargin{margin:30px 0px!important;}
i.ion-android-refresh.updateBankAc {
  position: absolute;
  margin-left: 5px;
  cursor: pointer;
}
.unmatchwrapper{padding:20px!important}
.unmatchpayment .ant-col-xl-12 {
  flex: 0 0 49.5%;
  max-width: 49.5%;
}
.tfSuccess span.anticon.anticon-check-circle {
  color: #C1D82F; text-align:center; font-size:40px
}
.tfSuccess  {
  text-align:center;
}
.unmatchpayment .ant-select-single:not(.ant-select-customize-input) .ant-select-selector{    padding: 0 5px;}
.tbl_payments table .multi_item_td .btn_pd {
  margin-top: 5px;
}
.tbl_payments table td {
  padding: 8px 5px!important;
}
.unmatchwrapper h3 {
  font-size:18px!important;
}
.react-datepicker-wrapper input[disabled] {
  background: #f5f5f5;
  cursor: not-allowed;
}
.longBankAc{padding-right:0!important;word-wrap:break-word}
.personalinfo .ant-row {
  margin: 15px 0;
}
.auditModal .ant-modal-close-x {
  width: 35px;
  height: 35px;
  line-height: 35px;
}
.auditModal .ant-modal-close-x {
  width: 35px;
  height: 35px;
  line-height: 35px;
}
span.transWithinfo {
  min-width: 100px;
  display: flex;
}
.transfersharemodal .ant-modal-title,.transfersharemodal  .ant-modal-footer {
   text-align: left!important;
}
.MT15{margin-top:15px!important}
.updateAcc{margin-top: 3px;
  padding-left: 0!important;}
  .pephinttext .ant-tooltip {
    max-width: 540px;font-weight: 400;
}
textarea.ant-input{resize:none;}
span.shareholdwidth {
  max-width: 150px;
  display: inline-block;
}
.ML10{margin-left:10px!important}
.legalTable td {
  min-width: 150px;
  white-space: nowrap;
}
.lineheigh15 .label {
  line-height: 14px;
  top: 12px;
}
.focuslabel.lineheigh15 .label,.lineheigh15 .label.label-float {
  top: -11px;
}
.multiUser{
    width: 49%;
    margin-bottom: 15px;
    border: 1px solid rgb(233, 233, 233);
    background:white;
    box-shadow: 0 12px 36px 0 rgba(69, 88, 157, .08);
    text-align:center !important;
}
.multiUser.disableUser  {
  background: rgb(245, 245, 245) !important;
}
.multiuserTitle{
  font-weight:bold;
  font-size: 20px;
  margin-bottom:-20px;
  text-align:center !important;
}
.pan_download{
  height: 30px;
  padding: 0px 4px !important;
  margin-left: 10px;
}
.selectmethod .get-account {
  display: block;
  font-size: 12px;
  line-height: 10px;
  font-weight: normal;
  margin: 10px 0px;
  color: rgb(105, 105, 105);
}
.selectmethod .most-secure {
  font-size: 12px;
  line-height: 12px;
  background-color: rgb(199, 224, 220);
  padding: 4px;
  border-radius: 4px;
}
.selectmethod img {
  width: 45px;
  position: absolute;
  top: -4px;
  right: 0;
}
.selectmethod {
  text-align: left;
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  padding: 10px;min-width: 450px;
}
.identify sup {
  top: 4px;
  font-size: 25px;
}
.selectmethod:hover{border: 1px solid #999;} 
.selectmethod .ant-radio-wrapper {display:block}
.selectmethod .ant-radio-wrapper .ant-radio{    vertical-align: top;}
.selectmethod .ant-radio-wrapper .ant-radio ~ span{display:inline-block}
.identify .identitynext{
  position: absolute;
  right: -50%;
  bottom: -30%;
}
.identify .identitywrapper{gap:0}
.identify .identitywrapper .ant-radio-group{width:100%}
.identify a{text-decoration:underline;margin-right:2px}
.identify .blueColor{color:#59cbe8}
.selectmethodouter {
  text-align: left;
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  padding: 10px;min-width: 450px;
}
span.register_nonPadding{
  top:15px!important;
}
span.register_nonPadding1{
  top:15px!important;
  right: 19px !important;
}
.otp_model .otp_title{
  margin: 0px 30px;
  padding: 30px 0px 0px 0px;
}
.isoSignUpPage .topbarwrapper, .isoSignInPage .topbarwrapper ,.homepagewrapper .topbarwrapper{
  position: absolute;
  left: 0;
  right: 0;
  z-index: 99;
  top: 12px;
  box-shadow: none;
}
.isoSignUpPage .topbarwrapper .isomorphicTopbar, .isoSignInPage .topbarwrapper .isomorphicTopbar ,.homepagewrapper .topbarwrapper .isomorphicTopbar{
  width: 100%;
  background: transparent;
  height: 80px; box-shadow: none;border:0
}
.isoSignUpPage .topbarwrapper .isomorphicTopbar .isoRight, .isoSignInPage .topbarwrapper .isomorphicTopbar .isoRight, .homepagewrapper .topbarwrapper .isomorphicTopbar .isoRight{
  align-items: self-start;
}
.isoSignUpPage .isomorphicTopbar .isoLeft .cvsologo, .isoSignInPage .isomorphicTopbar .isoLeft .cvsologo,.homepagewrapper .isomorphicTopbar .isoLeft .cvsologo{display:none}
.error_padding{
  margin: 0px 60px;
}
.emailBreak{word-break:break-all}
.alignBtn .fileContainer{align-items:start}
.grey-row {
  color: rgba(0, 0, 0, 0.25) !important;
  border-color: #d9d9d9 !important;
  background: #f5f5f5 !important;    
  cursor: not-allowed;
 
    opacity:.7;
    pointer-events: none;
}
.handleScrBr .ant-select-selector::-webkit-scrollbar-thumb {
  cursor: default;
}
.hyphen {
  margin-left:40px;
}
.compStructMdl .ant-form-item {
  margin-bottom: 5px;
}
.compStructMdl{
  width: 600px!important;
}
// input .inputBoxPadding{
//   padding-left:5px !important;
// }
.font10{font-size:10px}
.font11 {font-size:11px}
.borderRight .ant-col {
  border-left: 1px solid #19bcb9; color:#19bcb9;text-align: left;
}
.footer-info .borderRight .ant-col-xl-4{width:16%;padding: 0 10px !important; }
.footer-info .borderRight .ant-col-xl-5{width:20%;padding: 0 10px !important;}
 .tableborderTop{
  border-top :1px solid #19bcb9;padding-top: 10px;;
  }
.contactinforwrapper .address .ant-row {
    margin-bottom: 0;
}
   .contactinforwrapper  #basic3 .ant-checkbox-wrapper{margin-bottom:10px}
   th.ant-table-cell.comTitleWidth {
    min-width: 150px;
}
    .investtooltip .ant-tooltip-inner {
    min-width: 680px;
}
.error_compStruc{
  border: 1px solid #ff4d4f;
}
 .commRegText {
    position: relative;
    bottom: 4px;
    font-size: 10px;
    display: flex;
    flex-wrap: nowrap;
  }
    .legalTable th.ant-table-cell {
    min-width: 100px;
}
.multiUser button {
  width:100%;
  border:0 !important;
  height: auto !important;
  padding: 20px 20px !important;
}
.multiUser:hover { 
  border:1px solid rgb(68, 130, 255);
  color: rgb(68, 130, 255);
  border-radius:5px;
}
.multiUser.disableUser:hover{
  background: rgb(245, 245, 245) !important;
  border:1px solid rgb(0, 0, 0, .3);
  border-radius:5px;
}
.logInPage .identitywrapper {
  max-width: 850px;
  flex-wrap: wrap;
}
.accType {
  dispaly: inline-block;
  word-break: break-all;
  white-space: normal !important;font-size: 14px !important;
  }
    .invester_details_data .legalTable th.ant-table-cell:nth-child(4), .invester_details_data .legalTable th.ant-table-cell:nth-child(7), .invester_details_data .legalTable th.ant-table-cell:nth-child(8), .invester_details_data .legalTable th.ant-table-cell:nth-child(9) {
    min-width: 165px;
}
   .ant-select-single .ant-select-selector .ant-select-selection-placeholder{
    line-height: 48px!important;}
    .fullShare{
      text-align: center!important;
    }
    .partialShare{
      text-align: center!important;
    }
      .lightBlack b {
    color: #000;
}
    .ant-tooltip table th, .ant-tooltip table td {
    padding: 0px 6px;
    font-size: 12px;vertical-align: top;
}
.currinttext .ant-tooltip {
    max-width: 600px;
    font-weight: 400;
}
.logInPage.itsmeLogin .identitywrapper{
  width: 850px;
}
  th.ant-table-cell.pOwner {
    min-width: 200px;
}
    .lineheigh15.labelSpace .label {
   left:7px!important;
    right: 5px;
}
   .inputspace.ant-input-affix-wrapper {
    padding: 0 5px !important;
}
    .lineheigh15.countryreg  .label {
    right: 10px;
}
    .disabled {
    color: rgba(0, 0, 0, 0.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    box-shadow: none;
    cursor: not-allowed;
    opacity: 1;
}
    .disabled a {
    color: rgba(0, 0, 0, 0.25);
    pointer-events: none;
}
    .ant-modal.compStructMdl .ant-form label {
    font-size: 13px;
    padding-right: 22px;
}
    .ant-modal.compStructMdl .focuslabel  .label, 
    .ant-modal.compStructMdl .label.label-float {
    padding-right: 5px;
}
    .setupitsme {
    position: absolute;
    bottom: 70px;
    left: 50px;
    font-size: 14px;
    font-variant: tabular-nums;
}
 .setupitsme a{
  text-decoration:underline;
}
    .ant-btn-info {
    background: #1890ff;
    border: 1px solid #1890ff;
    color: #fff;
}
.wrapPepType {
  white-space: normal !important;
}
th.ant-table-cell.wrapPepType {
    min-width: 350px;
}
.portalBtn{
  font-size: 14px;
  font-variant: tabular-nums;
}
.portalBtn a{
  text-decoration:underline;
}
form .ant-mentions, form textarea.ant-input{
  height: 48px !important;
}
.breakReviewAddQues {
  word-wrap: break-word;
}
.tab_error .ant-tabs-nav .ant-tabs-tab[data-node-key="7"]{
  border: 1px solid #ff4d4f!important;
}
.balFontSize{
  font-size: 25px!important;
  padding-top: 5px!important;
}
.customLink{
  cursor: pointer;
  color: #59cbe8;
}
.customLink:hover{
  color: #0047ba;
}
.customLinks{
  cursor: pointer;
  color: #0047ba;
}
.customLinks:hover{
  color: #59cbe8;
}
.dashboardbtn{margin:0 0 10px}
#labelfocus112 label.label,#labelfocus121 label.label,
#labelfocus11.nrinNo label.label{
    line-height: 15px;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    margin-top: 25px;right: 1px;
}
    #labelfocus11.nrinNo label.label{
    line-height: 13px;
    font-size:13px;    right: auto !important;
    left: 7px;
}
    #labelfocus112.focuslabel label.label,
    #labelfocus121.focuslabel label.label,
     #labelfocus112 label.label.label-float,
     #labelfocus121 label.label.label-float,
     #labelfocus11.nrinNo label.label.label-float, 
     #labelfocus11.focuslabel.nrinNo label{
    top:0px; tranform:inherit;margin-top:0;right:1px
    }
    .labelFocusMT  label.label{margin-top: 0!important;}
    .ant-select-item-option-content{overflow: visible!important;white-space: normal!important;}
#labelfocus57 label.label {
   line-height: 12px;
    font-size: 12.5px;
    padding-right: 0;
    top: -7px;
    margin-right: 4px;
}
    #basic_compZipCode_help .ant-form-item-explain-error {
    font-size: 13.5px;
}
    .currinttext .ant-tooltip-inner td {
    width: 35%;
}
.error_box, .error_box:hover{
  border: 1px solid #ff4d4f!important;
}
.error_box.ant-input-affix-wrapper-focused{
  border-color: #ff7875!important;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2)!important;
}
.removeLineStyle:after, .removeLineStyle:before{content: none!important;}
.learnedAbout label.label {
    font-size: 13.5px;
    left: 8px;
    line-height: 16px;
}
    #labelfocus121.countryreg label.label{     right: 24px;}
    .errormsgfont .ant-form-item-explain-error{font-size: 13px;}
.errorBorder .ant-select-selector {
    border: 1px solid #ff4d4f !important;
}
.infoIconSize{
  width: 13px;
  height: 13px;
}
  .onboardHeading{
    margin-top:30px;
    text-align: center;
    color: #19bcb9;
    font-weight:bold;font-size:16px;
}
.onboardBtn{
    padding: 15px 35px 35px;
    text-align: center;
    margin: 10px 10px 0 40px;
}
    @media not all and (min-resolution: 0.001dpcm) {
    .contactinforwrapper .ant-tabs-tab-active .ant-tabs-tab-btn{font-weight:500!important}
    }
    @supports (-webkit-touch-callout: none) and (not (selector-list-argument: all)) {
 .contactinforwrapper .ant-tabs-tab-active .ant-tabs-tab-btn{font-weight:500!important}
 }
 @media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
 .contactinforwrapper .ant-tabs-tab-active .ant-tabs-tab-btn{font-weight:500!important}
  }
}
  .contactinforwrapper .ant-tabs-tab-btn {
    white-space: initial;
    text-align: left;
}
    .invester_details_data.legalinvetordetail .ant-card-body {
    padding: 10px 24px !important;
}
    .ant-table-wrapper.legalTable {
    margin-bottom: 10px;
}
form textarea.setAutoHeight{height:auto!important;}
.setShareIcon{
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 22px; 
}
  .decMaxWidth.ant-col-xl-8{max-width:31%}
  .PDL0{padding-left:0!important}
  .ant-modal .ant-table table tr:last-child td {
    border-bottom: 0;
}
.docErrors{
  color:#ff4d4f;
}
.uploadIcons{
  font-size: 20px !important; 
  color: rgb(24, 144, 255) !important;
  justify-content: center !important;
}
.uploadFile{
  display: flex !important;
  border-right: 1px solid #e9e9e9;
  padding: 0 10px !important;
  align-items: center; 
  max-Width: 200px;
  justify-content: space-between;
}
.uploadFileDisplay{
  overflow: hidden; 
  text-Overflow: ellipsis; 
  white-Space: nowrap;
}
.docModal{
  width: 600px !important;
}
.docModal .ant-modal-content{
  height: 375px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.docModal .ant-modal-body{
  height: 70%;
  padding: 0 24px;
}
.docModal .ant-modal-content .ant-modal-body .ant-upload-drag-container .ant-upload-text{
  width: 100%;
  margin: 0;
  padding: 4px;
}
.drag-btn{
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: end;
}
.docModalGridCol .ant-upload.ant-upload-drag {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 8px !important;
}
.docModalRow{
  height: 100%;
  margin: 0;
}
.docModalGridCol{
  display: grid !important;
  align-items: center;
}
.scrollableList{
  height: 91%;
  overflow: auto;
}
.scrollableList .ant-spin-container{
  transform: none;
}
.ant-upload.ant-upload-drag.docBrdErr {
  border: 1px solid #ff4d4f !important;
}
.docModalRow .docModalsetHig{
  height: 100%
}
.multiDocBtn{
  font-size: 12px;
  padding: 6px 10px;
  background: #3f4257;
  border-radius: 30px;
  color: white;
  font-weight: 300;
  transition: all 0.2s ease-in;
  outline: none;
  border: none;
  height: 39px;
  width: 150px;
  white-space: break-spaces;
  word-break: break-all;
}
.multiDocBtn:hover{
  background: #545972;
}
.multiDocBtn:focus{
  background: #3f4257
}
.docModalsetHig h3{
  text-align: center;
}
.docQuesDivider{
  padding-top: 20px;
  border-top: 1px solid #e9e9e9;
}
.borderWrapper{
  border: 2px solid red !important;
  padding: 5px 10px !important;
  border-radius: 8px;
  font-size: 14px;
  width: fit-content;
}
.docListItem{
  flex-direction: column;
  align-items: start!important;
}
.displayDocItem{
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.uploadDocReviewDivider{
  padding-top: 5px;
  border-top: 1px solid #e9e9e9;
}
.multiColCenter{
  display: flex !important;
  flex-direction: column;
  align-items: center;
}
.docTooltip .ant-tooltip-inner{
  font-size: 12px;
}
.lastuploadFile{
  border: none;
}
.configDivSwitch{
  display: flex;
}
.configDivHeading{
  text-align: end;
}
.configDivHeading .ant-switch{
  margin-left: 20px;
}
.scrolfileList{
  max-height: 80px;
  text-overflow: ellipsis;
  overflow: auto;
  white-space: nowrap;
}
.ant-modal-wrap div[aria-hidden="true"] {
display: none;
}
.spanHeading{
  font-weight: bold;
}
.LR-padding{
  padding: 0 20px;
}
.transViewName{
  font-weight: bold;
   font-size: 24px!important;
   margin:0!important
}
.tableFAQ {
  line-height: 1.5;
  padding: 16px;
  background-color: #DCF0C8;
  margin-top: 24px;
}
.custom-bullet p {
  position: relative;
  padding-left: 15px;
  margin-top: 8px;
  margin-left: 15px;
}
.bullet-symbol {
  position: absolute;
  left: 0;
  top: 0;
  color: #000;
  font-weight: bold;
}
.qr_model{
  width: 1500px;
  margin: 0px 30px;
  padding: 30px 0px 0px 0px;
  min-height: 450px;
}
.qr_model .ant-modal-content {
  width: 520px;
}
.qr_model .ant-modal-body {
  margin: 0px 30px;
  padding:20px 30px !important;
  min-height: 400px;
}
  `;


export default GlobalStyles;

